import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";
import DocumentControlHeader from "./DocumentControlHeader";
import { t } from '../../i18n';

export class IncidentInvestigationProcedure extends Component {

    render() {
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'incidentInvestigation'}
            title={ t('support.procedure.P20.title') }
            exportTitle={ t('support.procedure.P20.exportTitle') }
            exportFileName={'incident_investigation.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (IncidentInvestigationProcedure);